const Adress = {
    backendUrl: 'http://127.0.0.1:8000',
  };
  
  export default Adress;